var isOnScreen = require('../util/isOnScreen');
var PageScrollIndicator = {};
PageScrollIndicator.init = function () {
  var jsContent = document.getElementById("js-content");
  function scrollIndicator() {
    // we remove the offset of the #js-content so that we indicating from it.
    var windowScroll = (document.body.scrollTop || document.documentElement.scrollTop) - jsContent.offsetTop;
    // we are interested only by the height of the #js-content
    var documentheight = jsContent.offsetHeight;
    // remaining is the same
    var scrolledPercent = windowScroll / documentheight * 100;
    document.getElementById("scroll-indicator").style.width = scrolledPercent + "%";
  }
  window.onscroll = function () {
    scrollIndicator();
  };
};

// PageScrollIndicator.init();

export var scrollToElement = function scrollToElement(targetEl) {
  var adjustment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
  if (targetEl.length === 0) return;
  var navMessageHeight = $("#js-main-nav-msg").height() || 0;
  var navMenuHeight = $("#js-nav-menu").height() || 0;
  var navHeight = navMessageHeight + navMenuHeight + adjustment;
  if ($("body").hasClass("is-admin-active") && $("#wpadminbar")) {
    navHeight = navHeight + $("#wpadminbar").height();
  }
  $("html, body").stop(true).animate({
    scrollTop: targetEl.offset().top - navHeight
  }, delay, 'linear');
};


// WEBPACK FOOTER //
// ./scripts/components/scroll.js